import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-692cf8b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("； ")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 较去年同比增长 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ，净利润 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 元，较去年同比增长 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("。 ")
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "预测年报每股收益"),
  /*#__PURE__*/_createElementVNode("li", null, "预测年报净利润")
], -1))
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      (_ctx.info.EndDate || (_ctx.data || []).length || (_ctx.data1 || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.info.EndDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(" 截至 " + _toDisplayString(_ctx.moment(_ctx.info.EndDate * 1000).format('YYYY-MM-DD')) + " , 6 个月以内对此公司的 " + _toDisplayString(_ctx.info.ForYear) + " 年度业绩作出预测的机构共有 ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.info.AgentNum) + " 家 ", 1),
                  _hoisted_3
                ]))
              : _createCommentVNode("", true),
            (_ctx.info.EndDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(" 预测 " + _toDisplayString(_ctx.info.Year) + " 年，每股收益", 1),
                  _createElementVNode("strong", null, _toDisplayString((_ctx.info.EPS || 0).toFixed(2)) + " 元", 1),
                  _hoisted_5,
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.info.EPSGrowth > 0 ? 'red' : _ctx.info.EPSGrowth < 0 ? 'green' : '')
                  }, _toDisplayString((_ctx.info.EPSGrowth || 0).toFixed(2)) + "%", 3),
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(_ctx.getNumber(_ctx.info.PNetProfit)), 1),
                  _hoisted_7,
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.info.PNetProfitGrowth > 0 ? 'red' : _ctx.info.PNetProfitGrowth < 0 ? 'green' : '')
                  }, _toDisplayString((_ctx.info.PNetProfitGrowth || 0).toFixed(2)) + "% ", 3),
                  _hoisted_8
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, " 截至 " + _toDisplayString(_ctx.moment(new Date().getTime()).format('YYYY-MM-DD')) + ", 6 个月以内暂未有机构对此公司的—年度业绩作出预测 ", 1)),
            _createVNode(_component_Charts, {
              id: "yjyccharts",
              option: _ctx.option
            }, null, 8, ["option"]),
            ((_ctx.data || []).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  ((_ctx.data || []).length)
                    ? (_openBlock(), _createBlock(_component_Table, {
                        key: 0,
                        data: _ctx.data,
                        columns: _ctx.columns,
                        bordered: true,
                        pagination: false
                      }, null, 8, ["data", "columns"]))
                    : _createCommentVNode("", true),
                  ((_ctx.data || []).length)
                    ? (_openBlock(), _createBlock(_component_Table, {
                        key: 1,
                        data: _ctx.data,
                        columns: _ctx.columns2,
                        bordered: true,
                        pagination: false
                      }, null, 8, ["data", "columns"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}